export default __webpack_public_path__ + "static/media/esports-ctg.c32190c0.webp";